import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useStore } from "@/context/Store";
import { http } from "@/lib/api";
import { Container, useSeo } from "@/components/site/common";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { clearCart } = useStore();
  const [state, setState] = useState({ status: "checking" });
  useSeo("Pagamento");
  useEffect(() => {
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await http.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState({ status: "paid", number: data.order_number }); clearCart(); return; }
        if (data.payment_status === "expired") return setState({ status: "failed" });
      } catch { return setState({ status: "failed" }); }
      if (++n < 15 && !stop) setTimeout(poll, 2000); else setState({ status: "pending" });
    };
    if (sid) poll(); else setState({ status: "failed" });
    return () => { stop = true; };
  }, [sid, clearCart]);

  return (
    <Container className="py-24 text-center">
      <div data-testid="payment-result" data-status={state.status}>
        {state.status === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[var(--violet)]" /><p className="mt-4">A confirmar o pagamento…</p></>}
        {state.status === "paid" && <><CheckCircle2 className="mx-auto h-14 w-14 text-[#1faa53]" /><h1 className="mt-6 font-display text-5xl font-bold">Obrigado!</h1><p className="mt-3 text-[var(--muted-ink)]" data-testid="payment-order-number">Pagamento confirmado. Encomenda {state.number}.</p><p className="text-sm text-[var(--muted-ink)]">Vamos entrar em contacto quando o teu pedido seguir.</p><Link to={`/acompanhar?n=${state.number}`} className="btn-primary mt-6" data-testid="payment-track-link">Acompanhar pedido</Link></>}
        {state.status === "pending" && <><p className="font-display text-3xl font-bold">Pagamento em processamento</p><p className="mt-2 text-sm">Assim que for confirmado, a DUSA recebe o teu pedido.</p></>}
        {state.status === "failed" && <><XCircle className="mx-auto h-12 w-12 text-red-500" /><p className="mt-4 font-display text-3xl font-bold">Não foi possível confirmar o pagamento</p></>}
        <Link to="/" className="btn-ghost mt-8">Voltar à loja</Link>
      </div>
    </Container>
  );
}

export function PaymentCancel() {
  useSeo("Pagamento cancelado");
  return (
    <Container className="py-24 text-center">
      <div data-testid="payment-cancelled">
        <p className="font-display text-4xl font-bold">Pagamento cancelado</p>
        <p className="mt-3 text-[var(--muted-ink)]">O teu carrinho continua guardado.</p>
        <Link to="/checkout" className="btn-primary mt-8">Voltar ao checkout</Link>
      </div>
    </Container>
  );
}
